import Vue from "vue"
// tslint:disable-next-line:no-submodule-imports
import { VueConstructor } from "vue/types/vue"

/** refsに型をつける */
export function vueWith<T>(): VueConstructor<Vue & T> {
  return Vue as any
}
